export default __webpack_public_path__ + "static/media/Stand_FullT.cdf52479.png";